import moment from 'moment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Bullets from '../../../../../components/Bullets/Bullets';
import { Col } from '../../../../../components/Col';
import CardTitle from '../../../../../components/CrudWithSteps/components/CardTitle';
import { CustomButton } from '../../../../../components/CustomButton';
import { CustomNumberField } from '../../../../../components/CustomNumberField';
import { CustomTextField } from '../../../../../components/CustomTextField';
import GenericCardScreen from '../../../../../components/GenericCardScreen/GenericCardScreen';
import ArrowBackIcon from '../../../../../components/Icons/ArrowBackIcon';
import ArrowDownwardIcon from '../../../../../components/Icons/ArrowDownwardIcon';
import ArrowForwardIcon from '../../../../../components/Icons/ArrowForwardIcon';
import { DateMaskedInput } from '../../../../../components/MaskedInputs';
import NewAutoCompleteField from '../../../../../components/NewAutoCompleteField/NewAutoCompleteField';
import { Row } from '../../../../../components/Row';
import { CONTRATO_EDIT_ETAPA_VALIDACAO } from '../../../../../library/ContratoEditEtapas';
import {
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
} from '../../../../../library/ContratoVersoes';
import {
  contratoAditivoEditRoute,
  contratoDistratoEditRoute,
  contratoEditRoute,
} from '../../../../../library/Routes';
import {
  cadastroDistratoEntePrivado,
  changeContratoEntePrivadoEditingValue,
  editarDistratoEntePrivado,
} from '../../../../../store/modules/ContratosEntePrivadoActions';
import {
  clearAllProfessorGestorByEscola,
  loadAllProfessorGestorByEscola,
} from '../../../../../store/modules/ProfessoresActions';
import { getContratoTipoByRouteParams } from '../../../../../utils/ContratoUtils';
import { diferenceMonths } from '../../../../../utils/DateUtils';
import { getElementID } from '../../../../../utils/HTMLUtils';
import {
  allIsTrue,
  dateIsValid,
  integerIsValid,
  maskedValueRequiredIsValid,
  requiredIsValid,
} from '../../../../../utils/ValidationUtils';
import genericCardStyles from './../../../../../components/GenericCard/GenericCard.scss';
import styles from './DadosContrato.scss';
import GenericDados from './GenericDados';
import EscolasFieldContratos from 'components/EscolasField/EscolasFieldContratos';

const rootClassName = styles.rootClassName;
const rootElementId = 'contrato-dados-contrato';

const INITIAL_STATE = {
  sending: false,

  dataInicioChanged: false,
  totalMesesChanged: false,
  dataFimChanged: false,
  reembolsoChanged: false,
};

class DadosContrato extends GenericDados {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
    };
  }

  getActions = () => {
    return (
      <Row className={genericCardStyles.rootClassName + '-card-actions-row'}>
        <Col
          cols={[12, 12, 6, 6, 6]}
          className={genericCardStyles.rootClassName + '-card-actions-left'}
        >
          <CustomButton
            label={this.props.languageValues.anterior}
            theme='pufvYellow'
            onClick={this.toPrevContent}
            leftIcon={<ArrowBackIcon />}
          />
        </Col>
        {this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
        CONTRATO_VERSAO_DISTRATO ? (
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.concluirEAvancarEtapa}
              theme='pufvYellow'
              onClick={() => {
                if (this.formIsValid()) {
                  if (this.props.utils.editing()) {
                    this.toEdit(
                      this.props.contratosEntePrivado.contratoEditing
                        .idContrato,
                      2,
                      this.props.contratosEntePrivado.contratoEditing,
                      this.submitCallbackStart,
                      this.submitCallbackSuccess,
                      this.submitCallbackError
                    );
                  } else {
                    this.toSubmit(
                      2,
                      this.props.contratosEntePrivado.contratoEditing,
                      this.submitCallbackStart,
                      this.submitCallbackSuccess,
                      this.submitCallbackError
                    );
                  }
                }
              }}
              rightIcon={<ArrowDownwardIcon />}
              disabled={this.submitButtonIsDisabled()}
            />
          </Col>
        ) : (
          <Col
            cols={[12, 12, 6, 6, 6]}
            className={genericCardStyles.rootClassName + '-card-actions-right'}
          >
            <CustomButton
              label={this.props.languageValues.proxima}
              theme='pufvYellow'
              onClick={() => {
                if (this.formIsValid()) {
                  this.toSubmit(
                    0,
                    this.props.contratosEntePrivado.contratoEditing
                  );
                }
              }}
              rightIcon={<ArrowForwardIcon />}
              disabled={this.submitButtonIsDisabled()}
            />
          </Col>
        )}
      </Row>
    );
  };

  submitButtonIsDisabled = () => {
    return this.props.loading || this.state.sending || !this.formIsValid();
  };

  fieldDisabled() {
    if (!this.hasPermissions()) {
      return true;
    }
    const editing = this.editing();
    if (editing) {
      if (!this.props.auth.userPermissions.contratos.entePrivado.edit) {
        return true;
      }
    }
    return this.state.sending || this.props.loading;
  }

  fieldDisabledWhenAditivo = () => {
    if (
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_ADITIVO
    ) {
      return true;
    }
    return false;
  };

  reset() {
    this.setState(INITIAL_STATE);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.contratosEntePrivado.contratoEditing.idContrato !==
      this.props.contratosEntePrivado.contratoEditing.idContrato
    ) {
      this.loadRepresentantes(
        nextProps.contratosEntePrivado.contratoEditing.idEscola
      );
    }
  }

  UNSAFE_componentWillMount() {
    this.loadRepresentantes();
  }

  componentWillUnmount() {
    this.reset();
  }

  loadRepresentantes = (idEscola) => {
    const newIdEscola =
      idEscola || this.props.contratosEntePrivado.contratoEditing.idEscola;
    this.props.clearAllProfessorGestorByEscola();
    if (typeof newIdEscola === 'number' && newIdEscola > 0) {
      this.props.loadAllProfessorGestorByEscola(newIdEscola);
    }
  };

  idEscolaOnChanged = () => {
    this.loadRepresentantes();
  };

  dataInicioIsValid = () => {
    const value = this.props.contratosEntePrivado.contratoEditing.dataInicio;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataInicio.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataInicio.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataFimIsValid = () => {
    const value = this.props.contratosEntePrivado.contratoEditing.dataFim;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataFim.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataFim.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  totalMesesIsValid = () => {
    const value = this.props.contratosEntePrivado.contratoEditing.totalMeses;
    const required = requiredIsValid(
      value,
      this.props.languageValues.validations.totalMeses.required
    );
    const validation = integerIsValid(
      value,
      true,
      this.props.languageValues.validations.totalMeses.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };

  dataDistratoIsValid = () => {
    const value = this.props.contratosEntePrivado.contratoEditing.dataDistrato;
    const required = maskedValueRequiredIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.required
    );
    const validation = dateIsValid(
      value,
      this.props.languageValues.validations.dataDistrato.validation
    );
    if (!required.status) {
      return required;
    }
    if (!validation.status) {
      return validation;
    }
    return {
      status: true,
    };
  };
  f;
  onDataInicioChanged = (value) => {
    let months = diferenceMonths(
      value,
      this.props.contratosEntePrivado.contratoEditing.dataFim
    );
    this.props.changeContratoEntePrivadoEditingValue('totalMeses', months);
  };

  onDataFimChanged = (value) => {
    let months = diferenceMonths(
      this.props.contratosEntePrivado.contratoEditing.dataInicio,
      value
    );
    this.props.changeContratoEntePrivadoEditingValue('totalMeses', months);
  };

  onTotalMesesChanged = () => {
    this.mathTotalMeses();
  };

  mathTotalMeses = () => {
    let dataFim = '';
    if (this.dataInicioIsValid().status && this.totalMesesIsValid().status) {
      dataFim = moment(
        this.props.contratosEntePrivado.contratoEditing.dataInicio,
        'DD MM YYYY'
      )
        .add(
          'months',
          parseInt(this.props.contratosEntePrivado.contratoEditing.totalMeses)
        )
        .format('DD/MM/YYYY');
    }
    this.setValue({
      target: {
        name: 'dataFim',
        value: dataFim,
      },
    });
  };

  formIsValid() {
    const arr = [
      this.props.contratosEntePrivado.contratoEditing.idEscola !== -1
        ? true
        : false,
      this.props.contratosEntePrivado.contratoEditing.cpfProfessor !== ''
        ? true
        : false,
      this.props.contratosEntePrivado.contratoEditing.versaoContrato !==
      CONTRATO_VERSAO_DISTRATO
        ? this.dataInicioIsValid().status
        : true,
      this.props.contratosEntePrivado.contratoEditing.versaoContrato !==
      CONTRATO_VERSAO_DISTRATO
        ? this.totalMesesIsValid().status
        : true,
      this.props.contratosEntePrivado.contratoEditing.versaoContrato ===
      CONTRATO_VERSAO_DISTRATO
        ? this.dataDistratoIsValid().status
        : true,
    ];
    return allIsTrue(arr);
  }

  getGenericCardScreenProps = () => {
    return {
      GenericCardProps: {
        className: rootClassName,
        title: (
          <CardTitle onClick={this.openStepsMenu}>
            {this.props.languageValues.cadastroContratoDadosContrato}
          </CardTitle>
        ),
        actions: this.getActions(),
        bottomContent: (
          <Bullets
            total={this.props.totalBullets}
            selectedIndex={this.props.bulletsIndex}
          />
        ),
        CardContentProps: {
          className: rootClassName + '-card-content',
        },
        sending: this.state.sending || this.props.loading,
      },
    };
  };

  submitCallbackStart = () => {
    this.setState({
      sending: true,
    });
  };

  submitCallbackSuccess = () => {
    this.setState({
      sending: false,
    });
    const idContrato =
      this.props.contratosEntePrivado.contratoEditing.idContrato;
    const idAditivo = this.props.contratosEntePrivado.contratoEditing.idAditivo;
    const idDistrato =
      this.props.contratosEntePrivado.contratoEditing.idDistrato;
    const etapa = CONTRATO_EDIT_ETAPA_VALIDACAO;

    switch (this.props.contratosEntePrivado.contratoEditing.versaoContrato) {
      case CONTRATO_VERSAO_ADITIVO:
        this.props.history.push(
          contratoAditivoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idAditivo,
            etapa
          )
        );
        break;
      case CONTRATO_VERSAO_DISTRATO:
        this.props.history.push(
          contratoDistratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            idDistrato,
            etapa
          )
        );
        break;
      default:
        this.props.history.push(
          contratoEditRoute.getURLWithParams(
            getContratoTipoByRouteParams(this.props.match.params),
            idContrato,
            etapa
          )
        );
        break;
    }
  };

  submitCallbackError = () => {
    this.setState({
      sending: false,
    });
  };

  getEscola = () => {
    const idEscola = this.props.contratosEntePrivado.contratoEditing.idEscola;
    const nome = this.props.contratosEntePrivado.contratoEditing.nomEscola;
    if (idEscola && idEscola > 0 && nome && nome !== '') {
      return [
        {
          idEscola,
          nome,
        },
      ];
    }
    return [];
  };

  render() {
    return (
      <GenericCardScreen {...this.getGenericCardScreenProps()}>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            if (this.formIsValid()) {
              this.toSubmit(
                2,
                this.props.contratosEntePrivado.contratoEditing,
                this.submitCallbackStart,
                this.submitCallbackSuccess,
                this.submitCallbackError
              );
            }
          }}
        >
          <button
            type='submit'
            className='hidden-button'
            disabled={this.submitButtonIsDisabled()}
          ></button>
          {this.props.contratosEntePrivado.contratoEditing.versaoContrato !==
          CONTRATO_VERSAO_DISTRATO ? (
            <>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <EscolasFieldContratos
                    id={rootElementId}
                    label={this.props.languageValues.escola}
                    value={this.getEscola()}
                    onChange={(escola) => {
                      this.setValue({
                        target: {
                          name: 'idEscola',
                          value: escola ? escola.idEscola : -1,
                        },
                      });
                      this.setValue({
                        target: {
                          name: 'nomEscola',
                          value: escola ? escola.nome : '',
                        },
                      });
                      if (!escola) {
                        this.setValue({
                          target: {
                            name: 'cpfProfessor',
                            value: '',
                          },
                        });
                      }
                    }}
                    emptyText={
                      this.props.languageValues.validations.escolas.required
                    }
                    error={
                      this.state.escolasChanged && !this.escolasIsValid().status
                    }
                    estadosByCodCoop={
                      this.props.contratosEntePrivado.contratoEditing.codCoop
                    }
                    escolasByCodCoop={
                      this.props.contratosEntePrivado.contratoEditing.codCoop
                    }
                    disabled={
                      this.fieldDisabled() || this.fieldDisabledWhenAditivo()
                    }
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <NewAutoCompleteField
                    id={getElementID(rootElementId, 'professorGestor')}
                    label={this.props.languageValues.representantesLabel}
                    placeholder={
                      this.props.professores.professoresGestoresByEscola
                        .length === 0
                        ? this.props.languageValues.nenhumRepresentanteCarregado
                        : this.props.languageValues.selecioneUmRepresentante
                    }
                    options={this.props.professores.professoresGestoresByEscola.map(
                      (item) => {
                        return {
                          label: item.nome,
                          value: item.cpf,
                        };
                      }
                    )}
                    value={
                      this.props.contratosEntePrivado.contratoEditing
                        .cpfProfessor
                    }
                    onChange={(value) => {
                      const currValue = value && value.value ? value.value : '';
                      this.setValue({
                        target: {
                          name: 'cpfProfessor',
                          value: currValue,
                        },
                      });
                    }}
                    loading={
                      this.props.professores.loadingProfessorGestorByEscola
                    }
                    loadingMessage={
                      this.props.languageValues.loadingRepresentantesEntePrivado
                    }
                    error={
                      this.state.cooperativasChanged &&
                      !this.cooperativaIsValid().status
                    }
                    helperText={
                      this.state.cooperativasChanged &&
                      !this.cooperativaIsValid().status
                        ? this.cooperativaIsValid().error
                        : ''
                    }
                    disabled={
                      this.fieldDisabled() ||
                      this.props.contratosEntePrivado.contratoEditing
                        .idEscola === -1
                        ? true
                        : false || this.fieldDisabledWhenAditivo()
                    }
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-inicio')}
                    label={this.props.languageValues.cadastroContratoDataInicio}
                    name='dataInicio'
                    value={
                      this.props.contratosEntePrivado.contratoEditing.dataInicio
                    }
                    onChange={(event) => {
                      const value = event.target.value.trim();
                      if (value.length === 10) {
                        this.setValue(event, () =>
                          this.onDataInicioChanged(value)
                        );
                      }
                    }}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                    }}
                    helperText={
                      this.state.dataInicioChanged &&
                      !this.dataInicioIsValid().status
                        ? this.dataInicioIsValid().error
                        : ''
                    }
                    error={
                      this.state.dataInicioChanged &&
                      !this.dataInicioIsValid().status
                    }
                    disabled={this.fieldDisabled()}
                  />
                </Col>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, 'total-meses')}
                    label={this.props.languageValues.cadastroContratoTotalMeses}
                    name='totalMeses'
                    value={Number(
                      this.props.contratosEntePrivado.contratoEditing.totalMeses
                    ).toString()}
                    onChange={(event) => {
                      this.setValue(event, this.onTotalMesesChanged);
                    }}
                    onlyInteger={true}
                    onlyPositive={true}
                    error={
                      this.state.totalMesesChanged &&
                      !this.totalMesesIsValid().status
                    }
                    helperText={
                      this.state.totalMesesChanged &&
                      !this.totalMesesIsValid().status
                        ? this.totalMesesIsValid().error
                        : ''
                    }
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col cols={[12, 12, 6, 6, 6]}>
                  <CustomTextField
                    id={getElementID(rootElementId, 'data-fim')}
                    label={this.props.languageValues.cadastroContratoDataFim}
                    name='dataFim'
                    value={
                      this.props.contratosEntePrivado.contratoEditing.dataFim
                    }
                    onChange={(event) => {
                      const value = event.target.value.trim();
                      if (value.length === 10) {
                        this.setValue(event, () =>
                          this.onDataFimChanged(value)
                        );
                      }
                    }}
                    InputProps={{
                      inputComponent: DateMaskedInput,
                    }}
                    helperText={
                      this.state.dataFimChanged && !this.dataFimIsValid().status
                        ? this.dataFimIsValid().error
                        : ''
                    }
                    error={
                      this.state.dataFimChanged && !this.dataFimIsValid().status
                    }
                    disabled={this.fieldDisabled()}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <Row>
              <Col cols={[12, 12, 6, 6, 6]}>
                <CustomTextField
                  id={getElementID(rootElementId, 'data-distrato')}
                  label={this.props.languageValues.cadastroContratoDataDistrato}
                  name='dataDistrato'
                  value={
                    this.props.contratosEntePrivado.contratoEditing.dataDistrato
                  }
                  onChange={this.setValue}
                  InputProps={{
                    inputComponent: DateMaskedInput,
                  }}
                  disabled={this.fieldDisabled()}
                />
              </Col>
            </Row>
          )}
        </form>
      </GenericCardScreen>
    );
  }
}

DadosContrato.propTypes = {
  editing: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  contratos: state.contratos,
  contratosEntePrivado: state.contratosEntePrivado,
  professores: state.professores,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeContratoEntePrivadoEditingValue,
      clearAllProfessorGestorByEscola,
      loadAllProfessorGestorByEscola,
      cadastroDistratoEntePrivado,
      editarDistratoEntePrivado,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DadosContrato));
